module.exports = __webpack_public_path__ + "static/img/phone.baf4290.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/phone.jpg
// module id = TMVH
// module chunks = 1